import { Navigate, Route } from "react-router-dom";

import { List, NewAdmin, EditAdmin } from "../components";

const adminRoutes = [
    <Route index element={<Navigate to="list" replace />} key="platform-admins:index" />,
    <Route path="list" element={<List />} key="platform-admins:list" />,
    <Route path="new" element={<NewAdmin />} key="platform-admins:new" />,
    <Route path="edit/:id" element={<EditAdmin />} key="platform-admins:edit" />,
];

export default adminRoutes;
